// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3F6zF","content":"LayoutSettings_content__3qvYI"};